Ext.define('SA.lq.DatasetExportIntervalUsage', {
    constructor({limit, currentTotalUse, proposedTotalUse}) {
        this.limit = limit;
        this.currentTotalUse = currentTotalUse;
        this.proposedTotalUse = proposedTotalUse;
    },

    getCurrentTotalUsePercent() {
        return this.currentTotalUse / this.limit * 100;
    },

    getProposedTotalUsePercent() {
        return this.proposedTotalUse / this.limit * 100;
    }
});